<div class="list">
    <div class="list__label">{{ label }}</div>
    <div class="list__value"><ng-content></ng-content></div>
</div>
